/**
 * Le règlement des inscriptions affichées par un écran.
 *
 * Rend `undefined` pendant la lecture, `null` si elle a échoué (l'écran dit
 * alors « Indisponible », jamais `payment_status`), la carte sinon.
 *
 * La lecture se refait chaque fois que le TABLEAU change, pas son contenu :
 * l'appelant le mémorise sur ce qu'il a chargé (`useMemo` sur ses lignes),
 * et un rechargement de l'écran relit donc aussi les règlements — un
 * paiement rapproché entre-temps apparaît.
 */
import { useEffect, useState } from 'react';
import type { CarteDesReglements } from './reglement';
import { lireReglementDesInscriptions } from './reglement.supabase';

interface Lu {
  ids: readonly string[];
  carte: CarteDesReglements | null;
}

export function useReglementDesInscriptions(ids: readonly string[]): CarteDesReglements | null | undefined {
  const [lu, setLu] = useState<Lu | null>(null);

  useEffect(() => {
    if (ids.length === 0) {
      setLu({ ids, carte: new Map() });
      return;
    }
    let actif = true;
    lireReglementDesInscriptions([...new Set(ids)])
      .then((carte) => {
        if (actif) setLu({ ids, carte });
      })
      .catch((err) => {
        console.error('[inscriptions] reglement illisible', err);
        if (actif) setLu({ ids, carte: null });
      });
    return () => {
      actif = false;
    };
  }, [ids]);

  return lu?.ids === ids ? lu.carte : undefined;
}
